import { api } from '@setplex/tria-api'
import { createEvent, createStore, sample } from 'effector'
import { selectEpgChannelModel } from '~/features/epg/channels/select'
import { aye, exists } from '~/shared/helpers'
import { type CurrentProgramMediaUrl } from '~/shared/interfaces'

// init player
export const init = createEvent()

// reset widget on epg page left
export const left = createEvent()

// reset widget on sign out
export const reset = createEvent()

// fetch playback url for channel and maybe time shift
export const fetchUrl = createEvent<{
  channelId: number
  startTime?: number
  isRewind?: boolean
}>()

// currently playing channel id and available flag
export const $playing = createStore<{ id: number; available: boolean } | null>(
  null
)

// currently selected channel url
export const $url = createStore<CurrentProgramMediaUrl | null>(null) //
  .reset(api.player.loadChannelUrlFx.fail, api.session.signInFx.done)

// on new channel select -> update currently playing channel
// also playing channel be updated if it becomes available after purchase
sample({
  clock: selectEpgChannelModel.$active,
  source: $playing,
  filter: (playing, active) => {
    if (active == null) return false
    // `available` flag will be changed, if channel id is the same, but was purchased
    const available = aye(active.free) || aye(active.purchaseInfo)
    return playing?.id !== active.id || playing?.available !== available
  },

  fn: (_, active) => ({
    id: active!.id,
    available: aye(active!.free) || aye(active!.purchaseInfo),
  }),
  target: $playing,
})

// if selected new channel -> request to load playback url
sample({
  clock: $playing,
  filter: Boolean,
  fn: ({ id }) => ({ channelId: id }),
  target: fetchUrl,
})

// fetch playback url for channel by request
sample({
  clock: fetchUrl,
  target: api.player.loadChannelUrlFx,
})

// on channel url fetch success, update playback url
sample({
  clock: api.player.loadChannelUrlFx.doneData,
  source: fetchUrl,
  fn: (requested, url) =>
    exists(requested?.startTime)
      ? { ...url, timeShift: requested.startTime }
      : url,
  target: $url,
})

//
// left and reset logic
//

sample({
  clock: [left, reset],
  target: [$playing.reinit, $url.reinit],
})
